import { TDPK } from '../types';

function showModal() {
  return {
    type: TDPK.SHOW_MODAL,
  };
}

function hideModal() {
  return {
    type: TDPK.HIDE_MODAL,
  };
}

export const tdpkActions = {
  showModal,
  hideModal,
};
